<template>
  <div class="column is-hidden-print is-one-fifth-desktop is-one-fifth-tablet" style="text-align: left;" v-if="tournament">
    <aside class="menu">
      <p class="menu-label" style="margin-top: 15px;">
        Tournament
      </p>
      <ul class="menu-list">
        <li><router-link :to="'/tournaments/' + tournament.id + '/events'"><b-icon pack="fas" icon="calendar-check" size="is-small" style="opacity: 0.4;" /> &nbsp;  Events</router-link></li>
        <li><router-link :to="'/tournaments/' + tournament.id + '/teams'"><b-icon pack="fas" icon="bus-alt" size="is-small" style="opacity: 0.4;" /> &nbsp;  Teams</router-link></li>
        <li><router-link :to="'/tournaments/' + tournament.id + '/matches'"><b-icon pack="fas" icon="chalkboard-teacher" size="is-small" style="opacity: 0.4;" /> &nbsp;  Matches</router-link></li>
        <li><router-link :to="'/tournaments/' + tournament.id + '/rankings'"><b-icon pack="fas" icon="hockey-puck" size="is-small" style="opacity: 0.4;" /> &nbsp;  Rankings</router-link></li>
      </ul>


      <p class="menu-label" v-if="tournament.events && tournament.events.length > 0">
        Events
      </p>
      <ul class="menu-list">
        <li v-for="(e, index) in tournament.events" v-if="index < 20 || extendedEvents"><router-link style="padding-left: 0.4em; padding-right: 0.1em;" :to="'/tournaments/' + tournament.id + '/events/' + e.id + '/draws'"><b-icon pack="fas" :icon="(e.draws && e.draws.length > 0 ? 'paw' : 'star-half-alt')" size="is-small" :style="{ opacity: 0.4, color: (e.draws && e.draws.length > 0 ? 'black' : 'red') }" />&nbsp;  {{ e.shortName }}</router-link></li>
        <li style="margin-top: 15px; text-indent: 15px; cursor: pointer;" v-if="!extendedEvents && (tournament.events.length > 20)" @click="extendedEvents = true">Show more...</li>
      </ul>



      <p class="menu-label" v-if="event">
        {{ event.name }}
      </p>
      <ul class="menu-list" v-if="event">
        <li><router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/draws'"><b-icon pack="fas" icon="football-ball" size="is-small" style="opacity: 0.4;" /> &nbsp;  Draws</router-link></li>
        <li><router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/entries'"><b-icon pack="fas" icon="walking" size="is-small" style="opacity: 0.4;" /> &nbsp;  Entries</router-link></li>
      </ul>



      <p class="menu-label">
        General
      </p>
      <ul class="menu-list">
        <li><router-link to="/tournaments"><b-icon pack="fas" icon="globe-americas" size="is-small" style="opacity: 0.4;" /> &nbsp;  Tournaments</router-link></li>
        <li><a @click.prevent="triggerLogout"><b-icon pack="fas" icon="sign-out-alt" size="is-small" style="opacity: 0.4;" /> &nbsp;  Logout</a></li>
      </ul>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'TournamentMenu',
  props: {
    tournament: Object,
    event: {
      type: Object,
      required: false
    }
  },

  data: function() {
    return {
      extendedEvents: false
    }
  },

  methods: {
    triggerLogout() {
      this.$dialog.confirm({
        message: 'Are you sure you want to logout?',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('logout'); }
      });
    }
  }
}
</script>

<style scoped>
  p.menu-label {
    margin-top: 42px;
  }

</style>
